"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Annotation = function () { return (react_1.default.createElement("p", { className: "estimateForm-SubmitPageFooter_Annotation" }, "\u5165\u529B\u60C5\u5831\u306F\u3001SSL\u901A\u4FE1\u306B\u3088\u308A\u6697\u53F7\u5316\u3055\u308C\u3066\u9001\u4FE1\u3055\u308C\u307E\u3059\u3002\u304A\u5BA2\u69D8\u306E\u5165\u529B\u60C5\u5831\u306F\u7B2C\u4E09\u8005\u304B\u3089\u95B2\u89A7\u3055\u308C\u307E\u305B\u3093\u3002")); };
exports.default = Annotation;
